import { orpc } from "@/utils/orpc.client";

export function getArtistDiscographyCountsQueryOptions(artistId: string) {
  return orpc.music.getArtistDiscographyTypeCounts.queryOptions({ input: { id: artistId } });
}
